// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.

import { createSelector } from 'reselect'

import { fullSystemStateSelector } from './fullFileFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../types/system').AudioCache} AudioCache
 */

/**
 * @type {function(PlottrState): (AudioCache | Null)}
 */
export const audioCacheSelector = createSelector(fullSystemStateSelector, ({ audioCache }) => {
  return audioCache
})
